import React from 'react';
import './style.css'

const Newsletter = (props) => {
  
    const submitHandler = (e) => {
        e.preventDefault()
    }

    return(
        <section className={`${props.nwclass} wpo-newsletter-section-2 `}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <h2>Subscribe to Our newsletter</h2>
                        <p>Elevate your operations with tips, trends, and strategic advice tailored for logistics professionals, directly to your inbox.</p>
                    </div>
                    <div className="col-lg-8">
                        <div className="newsletter">
                            <div className="wpo-newsletter-form">
                                <form onSubmit={submitHandler}>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-sm-6">
                                            <div>
                                                <input type="text" className="form-control" placeholder="Name"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-6">
                                            <div>
                                                <input type="text" className="form-control" placeholder="Email"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-6">
                                            <button type="submit">Subscribe</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
     )
     
}

export default Newsletter;
